/* Angular Modules */
import {Injectable} from '@angular/core';
/* External Libraries */
import {ToastrService} from 'ngx-toastr';
/* Local Services */
import {LoggingService} from '@shared/services/logging.service';
import {environment} from '@environments/environment';

/// * local models */

@Injectable()
export class MessageService {
  currentPage: string;

  constructor(
    private toastr: ToastrService,
    private logging: LoggingService) {
  }

  setPage(page: string) {
    this.currentPage = page;
  }

  success(title: string, content: string, toast: boolean, activity: boolean, notification): void {
    if (!environment.production) {
      console.log(title.toUpperCase(), ':', content);
    }
    if (toast) {
      this.toastr.success(content, title);
    }
    this.processMessage(title, content, activity, notification, 'Success');
  }

  error(title: string, content: string, toast: boolean, activity: boolean, notification): void {
    if (!environment.production) {
      console.error(title.toUpperCase(), ':', content);
    }
    if (toast) {
      this.toastr.error(content, title);
    }
    this.processMessage(title, content, activity, notification, 'Error');
  }

  info(title: string, content: string, toast: boolean, activity: boolean, notification): void {
    if (!environment.production) {
      // tslint:disable-next-line:no-console
      console.info(title.toUpperCase(), ':', content);
    }
    if (toast) {
      this.toastr.info(content, title);
    }
    this.processMessage(title, content, activity, notification, 'Info');
  }

  warning(title: string, content: string, toast: boolean, activity: boolean, notification): void {
    if (!environment.production) {
      console.warn(title.toUpperCase(), ':', content);
    }
    if (toast) {
      this.toastr.warning(content, title);
    }
    this.processMessage(title, content, activity, notification, 'Warning');
  }

  // }
  clearActivity(): void {
    this.logging.clearActivities();
  }

  // getActivity(): Activity[] {
  //  return this.logging.readActivities();

  //  //this.logging.readActivities().subscribe(data => {
  //  //  return data;
  //  //});
  // }
  // getNotifications(): Notification[] {
  //  return this.logging.readNotifications();

  //  //this.logging.readNotifications().subscribe(data => {
  //  //  return data;
  //  //});

  clearNotifications(): void {
    this.logging.clearNotifications();
  }

  clearNotification(id: number): void {
    console.log(id);

    this.logging.clearNotification(id);
  }

  clear(): void {
    this.logging.clearAll();
  }

  private processMessage(title: string, content: string, activity: boolean, notification, status: string): void {
    if (activity) {
      this.logActivity(title, content, status);
    }
    if (notification) {
      this.logNotification(title, content, status);
    }
  }

  private logActivity(title: string, content: string, status: string) {
    this.logging.logActivity({'Id': 0, 'Time': new Date(), 'Page': this.currentPage, 'Action': title, 'Status': status});
  }

  private logNotification(title: string, content: string, status: string) {
    this.logging.logNotification({'Id': 0, 'Time': new Date(), 'Page': this.currentPage, 'Description': content, 'Read': false});
  }
}
